import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import generalService from './generalService'

// Get Campuses
export const GetCampuses = createAsyncThunk('campus-list', async (_, thunkAPI) => {
  try {
    return await generalService.getCampuses()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Start Impersonation
export const StartImpersonate = createAsyncThunk(
  'start-impersonate',
  async (data: {}, thunkAPI) => {
    try {
      return await generalService.startImpersonate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response)
      }
    }
  }
)

// Stop Impersonation
export const StopImpersonate = createAsyncThunk('stop-impersonate', async (data: {}, thunkAPI) => {
  try {
    return await generalService.stopImpersonate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetFaculties = createAsyncThunk('faculties-list', async (_, thunkAPI) => {
  try {
    return await generalService.getFaculties()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const Notifications = createAsyncThunk('notification', async (_, thunkAPI) => {
  try {
    return await generalService.notifications()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ReadNotification = createAsyncThunk('read-notify', async (id: string, thunkAPI) => {
  try {
    return await generalService.readNotification(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetUniversities = createAsyncThunk('get-universities', async (_, thunkAPI) => {
  try {
    return await generalService.getUniversities()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSchools = createAsyncThunk('get-schools', async (_, thunkAPI) => {
  try {
    return await generalService.getSchools()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSchoolSubjects = createAsyncThunk('get-school-subjects', async (_, thunkAPI) => {
  try {
    return await generalService.getSchoolSubjects()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSchoolClasses = createAsyncThunk('get-school-classes', async (_, thunkAPI) => {
  try {
    return await generalService.getSchoolClasses()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetKankorTerms = createAsyncThunk('get-kankor-terms', async (id: string, thunkAPI) => {
  try {
    return await generalService.getKankorTerms(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSubjectsTypes = createAsyncThunk('get-subject-types', async (_, thunkAPI) => {
  try {
    return await generalService.getSubjectTypes()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSemesters = createAsyncThunk('get-semesters', async (_, thunkAPI) => {
  try {
    return await generalService.getSemesters()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAcademicRanks = createAsyncThunk('get-academic-ranks', async (_, thunkAPI) => {
  try {
    return await generalService.getAcademicRanks()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSessions = createAsyncThunk('get-sessions', async (_, thunkAPI) => {
  try {
    return await generalService.getSessions()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetDays = createAsyncThunk('get-days', async (_, thunkAPI) => {
  try {
    return await generalService.getDays()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetEducationDegrees = createAsyncThunk(
  'get-educations-degree',
  async (_, thunkAPI) => {
    try {
      return await generalService.getEducationDegrees()
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetPositions = createAsyncThunk('get-positions', async (_, thunkAPI) => {
  try {
    return await generalService.getPositions()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSubjects = createAsyncThunk('get-subjects', async (_, thunkAPI) => {
  try {
    return await generalService.getSubjects()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetLanguages = createAsyncThunk('get-languages', async (_, thunkAPI) => {
  try {
    return await generalService.getLanguages()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetRelatives = createAsyncThunk('get-relatives', async (_, thunkAPI) => {
  try {
    return await generalService.getRelatives()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetProvinces = createAsyncThunk('get-provinces', async (_, thunkAPI) => {
  try {
    return await generalService.getProvinces()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetDistricts = createAsyncThunk('get-districts', async (_, thunkAPI) => {
  try {
    return await generalService.getDistricts()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})
export const GetNationalities = createAsyncThunk('get-countries', async (_, thunkAPI) => {
  try {
    return await generalService.getNationalities()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type GeneralState = {
  general: any
  notification: any
}

const initialState: GeneralState = {
  general: [],
  notification: [],
}

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(GetCampuses.fulfilled, (state, action: PayloadAction<any>) => {
      state.general = action.payload
    })
    builder.addCase(GetFaculties.fulfilled, (state, action: PayloadAction<any>) => {
      state.general = action.payload
    })
    builder.addCase(Notifications.fulfilled, (state, action: PayloadAction<any>) => {
      state.notification = action.payload
    })
  },
})

export const {reset} = generalSlice.actions
export default generalSlice.reducer
